import { Component, Input, OnInit } from '@angular/core';
import Decimal from 'decimal.js';
import { DateTime } from 'luxon';
import { Document } from '../../shared/sdk';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.css']
})
export class QrCodeComponent implements OnInit {

  QR_URL = 'https://porezna.gov.hr/rn';
  QR_DATE_FORMAT = 'yLLdd_HHmm';

  @Input() document: Document;

  constructor() { }

  ngOnInit() {
  }

  get paymentMethod(): string {
    let paymentMethod: string;

    if (this.document.payments && this.document.payments.length) {
      this.document.payments[0].type;
    }

    return this.document._fina.paymentType;
  }

  get qrValue(): string {
    const JIR = this.document._fina.JIR;
    const ZKI = this.document._fina.ZKI;
    const datv = DateTime.fromJSDate(this.document.issuedAt)
      .setZone('Europe/Zagreb')
      .toFormat(this.QR_DATE_FORMAT);

    const izn = new Decimal(this.document.totalWithTaxConverted || this.document.totalWithTax)
      .times(100)
      .toDP(0, Decimal.ROUND_FLOOR)
      .toString();

    let qrCode = this.QR_URL;
    qrCode += JIR ? `?jir=${JIR}` : `?zki=${ZKI}`;
    qrCode += `&datv=${datv}`;
    qrCode += `&izn=${izn}`;

    return qrCode;
  }

}
